import http from 'hub-http/clients/apiClient';
export const fetchComments = (objectId, objectType, oldestFirst = false, after) => {
  return http.get('/commenting/v2/comments', {
    query: Object.assign({
      objectType,
      objectId,
      sort: oldestFirst ? 'commentId' : '-commentId'
    }, after ? {
      after
    } : {})
  });
};
export const createComment = payload => {
  return http.post(`/commenting/v2/comments`, {
    data: payload
  });
};
export const updateComment = (commentId, payload) => {
  return http.patch(`/commenting/v2/comments/${commentId}`, {
    data: payload
  });
};
export const deleteComment = commentId => {
  return http.delete(`/commenting/v2/comments/${commentId}`);
};